/* istanbul ignore file */
import axios, { AxiosError, AxiosResponse } from "axios";
import { IAppConfig } from "../shared/types/config.types";
import { IApiTestParams } from "../shared/types/testing.types";
import { CONFIG_BASE_URL, CONFIG_ENDPOINT } from "./constants/urls.constants";

const CONFIG_API = axios.create({
  baseURL: CONFIG_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const configAPI = {
  getConfig: async (
    params?: IApiTestParams
  ): Promise<IAppConfig | AxiosError<IAppConfig>> => {
    return CONFIG_API({
      method: "GET",
      url: CONFIG_ENDPOINT,
      data: {},
    })
      .then(function (response: AxiosResponse<IAppConfig>) {
        return response.data;
      })
      .catch(function (error: AxiosError<IAppConfig>) {
        console.log(error);
        return error;
      });
  },
};

export default configAPI;
